// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"104":"c5c86b45","502":"8579ecd5","897":"d78863d4"}[chunkId] + ".chunk.js";
};